import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map } from 'rxjs';
import { AdhesionResumeModel } from '../../../helpers/objects/dto/sales-portal/adhesion-resume/adhesion-resume-model';

@Injectable({
  providedIn: 'root'
})
export class GeneralAdhesionService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  private readonly selectedApi : string = '';

  constructor(
    @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel,
    private http: HttpClient
  ) {
    this.appConfig = appConfigTemp;
    if(this.appConfig.platform === 'fhps'){
      this.selectedApi = this.appConfig.api + 'external/'
    } else {
      this.selectedApi = this.appConfig.api
    }
  }

  resume(id: number) {
    let url: string =
      this.selectedApi+ 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id + '/resume';

    return this.http.get<any>(url).pipe(map((result) => result.body as AdhesionResumeModel));
  }
  close(id: number, body: AdhesionResumeModel) {
    let url: string =
      this.selectedApi+
      'subscription/' +
      this.appConfig.apiPartnershipId +
      '/proposals/' +
      id +
      '/payment/close';

    return this.http.post<any>(url, body).pipe(map((response) => response.body));
  }

  printProposal(id: number) {
    let url: string =
      this.selectedApi + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id + '/print';

    return this.http.get<any>(url).pipe(
      map((response) => {
        return response.body;
      })
    );
  }
  setProposalAttachment(id: number, guidStr: string) {
    let url: string =
      this.appConfig.api + 'subscription/' + this.appConfig.apiPartnershipId + '/proposals/' + id + '/attachments';

    const body = {
      guid: guidStr
    };

    return this.http.post<any>(url, body).pipe(
      map((response) => {
        return response.body;
      })
    );
  }

  formatProduct(product: string): string {
    if (product.includes('#')) {
      product = product.substring(0, product.indexOf('#'));
    }

    return product;
  }
}
